module.exports = __webpack_public_path__ + "assets/ee35201bdb54342d990fc238b6dc35a6.mp3";